(function ($) {

    $('#subscription-products-show-all').on('click', function () {
        $('.subscription-products-info__products').removeClass('collapsed');
        $(this).hide();
    });

})(jQuery);